import { Router } from './app/lib/router';

function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
